/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {INudgeParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeParsedGameData";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {TombstoneGameMode} from "../../gamemode/TombstoneGameMode";
import {TombstoneServerDataParser} from "../TombstoneServerDataParser";
import {ITombstoneParsedServerData} from "./ITombstoneParsedServerData";
import {ITombstoneGameData} from "./ITombstoneServerData";
import {Tombstone} from "../../Tombstone";

export class TombstoneParsedGameData extends SpinParsedGameData implements INudgeParsedGameData, ITombstoneParsedServerData {

    private readonly _doReelNudge:boolean[];
    public get doReelNudge():boolean[] {
        return this._doReelNudge;
    }

    private readonly _extraSymbolsOnTop:string[][];
    public get extraSymbolsOnTop():string[][] {
        return this._extraSymbolsOnTop;
    }

    private readonly _superFreespinTriggeredThisSpin:boolean;
    public get superFreespinTriggeredThisSpin():boolean {
        return this._superFreespinTriggeredThisSpin;
    }

    private readonly _overlayWildsBeforeSpin:boolean[][];
    public get overlayWildsBeforeSpin():boolean[][] {
        return this._overlayWildsBeforeSpin;
    }

    private readonly _multiplierOnReel:number[];
    public get multiplierOnReel():number[] {
        return this._multiplierOnReel;
    }

    private readonly _bonusTriggeredThisSpin:boolean;
    public get bonusTriggeredThisSpin():boolean {
        return this._bonusTriggeredThisSpin;
    }

    private readonly _bonusPositions:number[];
    public get bonusPositions():number[] {
        return this._bonusPositions;
    }

    private readonly _numberOfBonusSpinsPlayed:number;
    public get numberOfBonusSpinsPlayed():number {
        return this._numberOfBonusSpinsPlayed;
    }

    private readonly _bonusSpinsLeft:number;
    public get bonusSpinsLeft():number {
        return this._bonusSpinsLeft;
    }

    constructor(rawData:ITombstoneGameData, dataParser:TombstoneServerDataParser) {
        super(rawData, dataParser);
        if (Tombstone.isActionSpinsActive){
            return;
        }

        this._doReelNudge = dataParser.parseDoReelNudge(rawData);
        this._extraSymbolsOnTop = dataParser.parseExtraSymbolsOnTop(rawData);
        this._superFreespinTriggeredThisSpin = dataParser.parseSuperFreespinTriggeredThisSpin(rawData);
        this._overlayWildsBeforeSpin = dataParser.parseOverlayWildsBeforeSpin(rawData);
        this._multiplierOnReel = dataParser.parseMultiplierOnReel(rawData);
        this._bonusTriggeredThisSpin = dataParser.parseBonusTriggeredThisSpin(rawData);
        this._bonusPositions = dataParser.parseBonusPositions(rawData);
        this._numberOfBonusSpinsPlayed = dataParser.parseNumberOfBonusSpinsPlayed(rawData);
        this._bonusSpinsLeft = dataParser.parseBonusSpinsLeft(rawData);
    }

    protected isFeatureTotalWin():boolean {
        return this.superFreespinTriggeredThisSpin || this.mode === TombstoneGameMode.SUPER_FREESPIN;
    }

    protected isNextFeatureTotalWin():boolean {
        return this.nextMode === TombstoneGameMode.SUPER_FREESPIN;
    }
}